module.exports = __webpack_public_path__ + "img/terradrone_g_center.20cb6a2e.png";